module.exports = __webpack_public_path__ + "img/guanbiIcon.60727c71.png";